import { render } from "./AddCongfiguration.vue?vue&type=template&id=3232c5d9&ts=true"
import script from "./AddCongfiguration.vue?vue&type=script&lang=ts"
export * from "./AddCongfiguration.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__